import type { ReactNode } from "react";
import {
  Header,
  MenuSection,
  type MenuSectionProps,
} from "react-aria-components";
import { menuStyle } from "./menuStyle.js";

export interface SimpleMenuSectionProps<T> extends Omit<
  MenuSectionProps<T>,
  "className" | "children"
> {
  /** Optional section header label. */
  label?: string;
  children: ReactNode;
}

export const SimpleMenuSection = <T extends object>({
  label,
  children,
  ...props
}: SimpleMenuSectionProps<T>) => {
  return (
    <MenuSection {...props}>
      {label ? (
        <Header className={menuStyle().sectionHeader()}>{label}</Header>
      ) : null}
      {children}
    </MenuSection>
  );
};
